module.exports = __webpack_public_path__ + "img/recipe.345e147b.png";